import { useState } from "react";
import { MESES, DIAS, STATUS } from "../constants";

export default function Calendario({ordens}){
  const agora = new Date();
  const [mes,setMes] = useState(agora.getMonth());
  const [ano,setAno] = useState(agora.getFullYear());
  const primeiro = new Date(ano,mes,1).getDay();
  const dias     = new Date(ano,mes+1,0).getDate();
  const celulas  = [...Array(primeiro).fill(null), ...Array.from({length:dias},(_,i)=>i+1)];

  const ordensNoDia = d => {
    const str = [ano, String(mes+1).padStart(2,"0"), String(d).padStart(2,"0")].join("-");
    return ordens.filter(o=>o.data_agendada?.slice(0,10)===str);
  };

  return(
    <div className="card mb-16" style={{padding:16}}>
      <div className="flex-row mb-16">
        <button className="btn btn-secondary" style={{padding:"3px 10px"}} onClick={()=>{if(mes===0){setMes(11);setAno(a=>a-1);}else setMes(m=>m-1);}}>‹</button>
        <strong style={{fontSize:15,minWidth:160,textAlign:"center"}}>{MESES[mes]} {ano}</strong>
        <button className="btn btn-secondary" style={{padding:"3px 10px"}} onClick={()=>{if(mes===11){setMes(0);setAno(a=>a+1);}else setMes(m=>m+1);}}>›</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:4}}>
        {DIAS.map(d=><div key={d} style={{textAlign:"center",fontSize:11,fontWeight:600,color:"var(--z-text-muted)",padding:"4px 0"}}>{d}</div>)}
        {celulas.map((dia,i)=>{
          if(!dia) return <div key={"e"+i}/>;
          const ords = ordensNoDia(dia);
          const hoje = dia===agora.getDate()&&mes===agora.getMonth()&&ano===agora.getFullYear();
          return(
            <div key={dia} style={{minHeight:64,border:"1px solid "+(hoje?"var(--z-blue)":"var(--z-border)"),borderRadius:6,padding:"4px 6px",background:hoje?"#eff6ff":"#fff"}}>
              <div style={{fontSize:12,fontWeight:hoje?700:400,color:hoje?"var(--z-blue)":"var(--z-text-secondary)",marginBottom:2}}>{dia}</div>
              {ords.map(o=>(
                <div key={o.id} title={"OS#"+o.id+" - "+o.cliente_nome}
                  style={{fontSize:10,background:STATUS[o.status]?.bg,color:STATUS[o.status]?.cor,borderRadius:3,padding:"1px 4px",marginBottom:2,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>
                  #{o.id} {o.cliente_nome}
                </div>
              ))}
            </div>
          );
        })}
      </div>
      <div className="flex-row" style={{marginTop:8,flexWrap:"wrap",fontSize:11}}>
        {Object.entries(STATUS).map(([k,{l,bg,cor}])=>(
          <span key={k}><span style={{display:"inline-block",width:12,height:12,background:bg,borderRadius:2,marginRight:4,verticalAlign:"middle"}}/>{l}</span>
        ))}
      </div>
    </div>
  );
}
